import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IYearlevel_map } from "../../../Pages/Yearlevel_map/IYearlevel_map";

export const AddYearlevel_mapSlice = createSlice({
  name: "AddYearlevel_mapSlice",
  initialState: {} as IReduxState<IYearlevel_map>,
  reducers: {
    addYearlevel_map: (state, _: PayloadAction<IYearlevel_map>) => {
      state.isLoading = true;
    },
    successaddYearlevel_map: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureaddYearlevel_map: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearAddYearlevel_mapResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  addYearlevel_map,
  failureaddYearlevel_map,
  successaddYearlevel_map,
  clearAddYearlevel_mapResponse,
} = AddYearlevel_mapSlice.actions;

export default AddYearlevel_mapSlice.reducer;
